export const DIRECTION = {
    BUY: "BUY",
    HOLD: "HOLD",
    SELL: "SELL"
};

export const COMMUNICATED_VIA = {
    EMAIL: "EMAIL",
    IM: "IM",
    IN_PERSON: "IN_PERSON",
    MESSAGE: "MESSAGE",
    PHONE: "PHONE",
    TRADE_IDEA: "TRADE_IDEA",
    TV: "TV"
};

export const VALIDITY_PERIOD = {
    VALIDITY_PERIOD_1D: "VALIDITY_PERIOD_1D",
    VALIDITY_PERIOD_2D: "VALIDITY_PERIOD_2D",
    VALIDITY_PERIOD_1W: "VALIDITY_PERIOD_1W",
    VALIDITY_PERIOD_1M: "VALIDITY_PERIOD_1M",
    VALIDITY_PERIOD_3M: "VALIDITY_PERIOD_3M",
    VALIDITY_PERIOD_6M: "VALIDITY_PERIOD_6M",
    VALIDITY_PERIOD_1YPLUS: "VALIDITY_PERIOD_1YPLUS"
};



/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/constants.js
 **/